// Desktop menu: one soft highlight that glides to the hovered item instead of each item lighting up on its own.
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll('.nav-desktop__tier-1').forEach((list) => {
    const place = (link) => {
      if (!link) {
        list.style.setProperty('--nav-o', '0');
        return;
      }
      const box = list.getBoundingClientRect();
      const rect = link.getBoundingClientRect();
      list.style.setProperty('--nav-x', `${rect.left - box.left}px`);
      list.style.setProperty('--nav-y', `${rect.top - box.top}px`);
      list.style.setProperty('--nav-w', `${rect.width}px`);
      list.style.setProperty('--nav-h', `${rect.height}px`);
      list.style.setProperty('--nav-o', '1');
    };
    const rest = () => place(list.querySelector('.nav-desktop__tier-1-link--active'));

    list.classList.add('nav-glide');
    list.classList.add('nav-glide--still');
    rest();
    requestAnimationFrame(() => list.classList.remove('nav-glide--still'));

    list.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const link = event.target.closest('.nav-desktop__tier-1-link');
      if (link && list.contains(link)) place(link);
    });
    list.addEventListener('pointerleave', rest);
    list.addEventListener('focusin', (event) => place(event.target.closest('.nav-desktop__tier-1-link')));
    list.addEventListener('focusout', rest);
    window.addEventListener('resize', rest, { passive: true });
  });
})();
